<template>
  <div>
    <v-button class="link" :url="link">{{ linkText }}</v-button>
  </div>
</template>

<script>
import VButton from "@/components/Button.vue";

export default {
  props: {
    link: String,
    linkText: String,
  },
  components: {
    VButton,
  },
};
</script>

<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
.link {
  background-image: url("~@/assets/images/arrow.svg");
  background-repeat: no-repeat;
  background-position: 90% 50%;
  background-size: 12px;
  margin-bottom: 1em;
  min-width: 180px;
}
</style>
